/** "en" → "English" in the reader's language; "mul" → the label for several languages. */
export default function languageName(code, locale, several) {
  if (code === 'mul') return several;
  try {
    return new Intl.DisplayNames([locale || 'en'], {
      type: 'language'
    }).of(code) || code;
  } catch (e) {
    return code;
  }
}
flarum.reg.add('ernestdefoe-flarumverse', 'common/languageName', languageName);